import * as React from 'react';
export const listSvg = React.forwardRef(function listSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.75 4.25C2.438 4.25 3 3.687 3 3c0-.688-.563-1.25-1.25-1.25C1.062 1.75.5 2.313.5 3c0 .7.563 1.25 1.25 1.25Zm0 5C2.438 9.25 3 8.687 3 8c0-.688-.563-1.25-1.25-1.25C1.062 6.75.5 7.313.5 8c0 .7.563 1.25 1.25 1.25Zm0 5C2.438 14.25 3 13.687 3 13c0-.688-.563-1.25-1.25-1.25-.688 0-1.25.563-1.25 1.25 0 .7.563 1.25 1.25 1.25Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 2.875C4 2.392 4.392 2 4.875 2h9.75a.875.875 0 0 1 0 1.75h-9.75A.875.875 0 0 1 4 2.875Zm0 5.126c0-.483.392-.875.875-.875h9.75a.875.875 0 0 1 0 1.75h-9.75A.875.875 0 0 1 4 8.001Zm0 5.124c0-.483.392-.875.875-.875h9.75a.875.875 0 0 1 0 1.75h-9.75A.875.875 0 0 1 4 13.125Z',
    }),
  );
});
listSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var list = {
  category: 'icon',
  colorable: true,
  name: 'list',
  svg: listSvg,
};
